import * as endpoints from '@Constants/endpoints';
import interceptor from '../interceptor';

const TEMPLATES = 'templates';

const _get = async props => {
    const { axios, pathUrl, params } = props;
    try {
        return (await axios.get(pathUrl, { params })).data;
    } catch (error) {
        if (error && error.response && error.response.status)
            throw {
                status: error.response.status,
                userFeedback: error.response.data.userFeedback || error.response.data.error
            };
        throw error;
    }
};

const _post = async (axios, pathUrl, params = {}) => {
    try {
        return (await axios.post(pathUrl, params)).data;
    } catch (error) {
        if (error && error.response && error.response.status)
            throw {
                status: error.response.status,
                userFeedback: error.response.data.userFeedback || error.response.data.error
            };
        throw error;
    }
};

export const list = async ({ header, params }) => {
    const pathUrl = `${endpoints.API_ACCOUNT}/${TEMPLATES}`;
    const axios = interceptor(header);
    return await _get({ axios, pathUrl, params });
};

export const create = async ({ header, data }) => {
    const pathUrl = `${endpoints.API_ACCOUNT}/${TEMPLATES}`;
    const axios = interceptor(header);
    return await _post(axios, pathUrl, data);
};

export const getById = async ({ header, id }) => {
    const pathUrl = `${endpoints.API_ACCOUNT}/${TEMPLATES}/${id}`;
    const axios = interceptor(header);
    return await _get({ axios, pathUrl });
};

const _put = async (axios, pathUrl, params = {}) => {
    try {
        return (await axios.put(pathUrl, params)).data;
    } catch (error) {
        if (error && error.response && error.response.status)
            throw {
                status: error.response.status,
                userFeedback: error.response.data.userFeedback || error.response.data.error
            };
        throw error;
    }
};

export const update = async ({ header, id, data }) => {
    const pathUrl = `${endpoints.API_ACCOUNT}/${TEMPLATES}/${id}`;
    const axios = interceptor(header);
    return await _put(axios, pathUrl, data);
};
